import { engineers, engineersLoadInProgress } from "./engineers";
import { startDate, endDate } from "../reducers/shifts-definitions-reducer";
import moment from "moment";

export const isLoadingShiftsDefinitions = state =>
  state.shiftsDefinitions.list === null;
export const shiftsDefinitionsError = state => state.shiftsDefinitions.error;

export const regionEngineers = (state, regionId) =>
  engineersLoadInProgress(state)
    ? null
    : engineers(state)
        .filter(
          engineer =>
            engineer.enabled === true && engineer.regionId === regionId,
        )
        .map(engineer => ({
          id: engineer.id,
          name: `${engineer.firstName} ${engineer.lastName}`,
        }));

export const selected = state => state.shiftsDefinitions.selected;

export const shiftsDefinitions = state =>
  isLoadingShiftsDefinitions(state)
    ? null
    : shiftsDefinitionsWithPlaceholder(existingShiftsDefinitions(state));

const shiftsDefinitionsWithPlaceholder = shiftsDefinitions => {
  const placeholders = [];
  for (
    let shiftDefinitionIndex = 0;
    shiftDefinitionIndex < shiftsDefinitions.length - 1;
    shiftDefinitionIndex++
  ) {
    const currentDefinition = shiftsDefinitions[shiftDefinitionIndex];
    const nextDefinition = shiftsDefinitions[shiftDefinitionIndex + 1];
    if (currentDefinition.end.getTime() !== nextDefinition.start.getTime()) {
      placeholders.push({
        // For the record, this is probably a bad place to do this.
        // And engineers should be already in the response, there shouldn't be a second request for them
        engineer: {
          firstName: "FREE",
          lastName: "",
        },
        start: currentDefinition.end,
        end: nextDefinition.start,
        priority: nextDefinition.priority,
      });
    }
  }
  const withPlaceholders = shiftsDefinitions.concat(placeholders);
  withPlaceholders.sort((shiftDefinition, otherShiftDefinition) =>
    moment(shiftDefinition.start).diff(otherShiftDefinition.start),
  );
  return withPlaceholders;
};

const existingShiftsDefinitions = state =>
  state.shiftsDefinitions.list.map(shiftDefinition => ({
    // For the record, this is probably a bad place to do this.
    // And engineers should be already in the response, there shouldn't be a second request for them
    engineer: engineers(state).find(
      engineer => engineer.id === shiftDefinition.engineerId,
    ),
    id: shiftDefinition.id,
    start: startDate(shiftDefinition),
    end: endDate(shiftDefinition),
    priority: shiftDefinition.priority,
  }));



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/selectors/shifts-definitions.js